export default __webpack_public_path__ + "static/media/FengduMap.b495db4d.jpg";